import React from "react";
import Footer from "./Footer";

import prod1 from "../img/product1.jpg";
import prod2 from "../img/product2.jpg";
import prod3 from "../img/product3.jpg";
import prod4 from "../img/product4.jpg";
import prod5 from "../img/product5.jpg";
import prod6 from "../img/product6.jpg";
import prod7 from '../img/shop.jpg'

const Gallery = () => {
  const images = [prod1, prod2, prod3, prod4, prod5, prod6, prod7];

  return (
    <>
    
    <div className='container mt-1 bg-success p-2 d-flex justify-content-center align-items-center rounded-3' >
        <h2 className="text-center mb-1 text-white">Gallery</h2>
      </div>


      <div className="container py-5">
       
        <div className="row g-4">
          {images.map((img, index) => (
            <div key={index} className="col-6 col-md-4 col-lg-3">
              <div className="card border-0 shadow-sm">
                <img
                  src={img}
                  alt={`Gallery ${index + 1}`}
                  className="card-img-top rounded"
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Gallery;
